import { establish } from '@im-frontend/utils/i18n';
import { currency, locale } from './namespaceInfo';

establish(locale, currency);
